import RemoteTable from "./Table";
import "./index.css";
const RemoteContents = ({ businessId }) => {
  return (
    <div className="remote-contents">
      <RemoteTable businessId={businessId} />
    </div>
  );
};

export default RemoteContents;
